// PollingPusherChannelData.js
'use strict';
import { connect } from 'react-redux';

import fetchRetainedEvents from '../action/fetchRetainedEvents.js';
import getRemoteConfigData from '../selector/getRemoteConfigData.js';
import getOperationData from '../selector/getOperationData.js';
import { PUSHER_CHANNEL_DATA_POLLING_MSEC } from '../RemoteConfigKeys.js';
import PollingPusherChannelData from '../component/PollingPusherChannelData.jsx';

const mapStateToProps = state => {
  return {
    inViewportUserIds: getOperationData(state, ['pusher', 'inViewportUserIds']),
    pollingMsec: getRemoteConfigData(state, PUSHER_CHANNEL_DATA_POLLING_MSEC),
  };
};

const mapDispatchToProps = dispatch => {
  return {
    fetchRetainedEvents: ({ channels }) =>
      dispatch(fetchRetainedEvents({ channels })),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PollingPusherChannelData);
